module.exports = __webpack_public_path__ + "static/media/Jatra_1_Billboard.349bf67e.jpg";